import { useLazyLoadQuery } from "react-relay";
import { useTranslation } from "@i18n/hooks";
import type { personalizedNotificationTemplates_PersonalizedNotificationTemplatesQuery } from "@relay/personalizedNotificationTemplates_PersonalizedNotificationTemplatesQuery.graphql";
import { PersonalizedNotificationTemplatesTable } from "./parts/personalized-notification-templates-table";
import { QUERY } from "./personalized-notification-templates.graphql";
import { BaseScreen } from "../../components/base-screen";

export const PersonalizedNotificationTemplatesScreen = () => {
	const { t } = useTranslation("common");
	const data =
		useLazyLoadQuery<personalizedNotificationTemplates_PersonalizedNotificationTemplatesQuery>(
			QUERY,
			{},
			{ fetchPolicy: "network-only" },
		);

	return (
		<BaseScreen title={t("personalizedNotificationTemplates.title")}>
			<PersonalizedNotificationTemplatesTable
				personalizedNotificationTemplatesFragmentRef={data}
			/>
		</BaseScreen>
	);
};
